export function useReveal(el: Ref<HTMLElement | undefined>, options?: { delay?: number }) {
  const isVisible = ref(false);

  if (import.meta.server) return { isVisible };

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    isVisible.value = true;
    return { isVisible };
  }

  onMounted(() => {
    const target = el.value;
    if (!target) return;

    if (options?.delay) {
      target.style.transitionDelay = `${options.delay}ms`;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          isVisible.value = true;
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(target);

    onUnmounted(() => observer.disconnect());
  });

  return { isVisible };
}
